import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IQuizListInfo, UseContext } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { QuestionnairesService } from "src/app/providers/questionnaires.service";

export class QuizListDataSource extends MatTableDataSourceBackendExtended<IQuizListInfo> {
  constructor(private questionnaireApi: QuestionnairesService) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<IQuizListInfo[]> {
    return this.questionnaireApi.findSpecificQuestionnaire(params).pipe(
      map((list: IQuizListInfo[]) => {
        for (const q of list) {
          q.useContext?.sort(UseContext.useContextSortAccess);
        }
        return list;
      })
    );
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
      Use this, the day we decide to make the page implements AbstractBackendTablePage
      */
    return of(0);
  }
}
